import Grid from '@mui/material/Grid';
import { InsertPhotoOutlined } from '@mui/icons-material';
import ChipInput from '../ChipInput/ChipInput';
import React from 'react';

const SUBSECTION_PADDING = { paddingTop: 8, paddingBottom: 8 };
const DESCRIPTION_STYLE = { color: 'var(--mui-palette-text-secondary)', fontSize: 14 };

const ImageInputComponent = ({ aiAssistantData, onPlaceholderSelected, availablePlaceholders, store }) => {
  return (
    <>
      <Grid item xs={12} style={SUBSECTION_PADDING}>
        <Grid container alignItems="center">
          <InsertPhotoOutlined />
          <span><b> Image input</b></span>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <span style={DESCRIPTION_STYLE}>
          Add an image URL for the AI to use when performing its job or task. The image can be .png,
          .jpg, .jpeg format
        </span>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: 12 }}>
        <ChipInput
          inputValue={aiAssistantData.imageContext}
          onPlaceholderSelected={onPlaceholderSelected}
          placeholders={availablePlaceholders}
          placeholder="Select placeholders"
          fullWidth
          onDelete={index => {
            store.getState().deleteChip(index);
          }}
        />
      </Grid>
    </>
  );
};

export default ImageInputComponent;
